import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import CookieConsent from "@/components/CookieConsent";
import MobileQuickContact from "@/components/MobileQuickContact";
import BackToTop from "@/components/BackToTop";
import Home from "@/pages/Home";
import Leistungen from "@/pages/Leistungen";
import MarkDaviz from "@/pages/MarkDaviz";
import AngelaPuxi from "@/pages/AngelaPuxi";
import Zeremonien from "@/pages/Zeremonien";
import FreieTrauungKrefeld from "@/pages/FreieTrauungKrefeld";
import Kosten from "@/pages/Kosten";
import Partner from "@/pages/Partner";
import Hoerbeispiele from "@/pages/Hoerbeispiele";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import DankeAnfrage from "@/pages/DankeAnfrage";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    lenisRef.current = lenis;
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="grain min-h-screen bg-creme text-ink">
      <BrowserRouter>
        <ScrollManager />
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/leistungen" element={<Leistungen />} />
            <Route path="/mark-daviz" element={<MarkDaviz />} />
            <Route path="/angela-puxi" element={<AngelaPuxi />} />
            <Route path="/zeremonien" element={<Zeremonien />} />
            <Route path="/freie-trauung-krefeld" element={<FreieTrauungKrefeld />} />
            <Route path="/kosten" element={<Kosten />} />
            <Route path="/partner" element={<Partner />} />
            <Route path="/hoerbeispiele" element={<Hoerbeispiele />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/danke-anfrage" element={<DankeAnfrage />} />
          </Routes>
        </main>
        <Footer />
        <CookieConsent />
        <MobileQuickContact />
        <BackToTop />
      </BrowserRouter>
    </div>
  );
}

export default App;
